import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";

export const AdminContentTab = ({ allStories, handleDeleteStory }) => (
  <Card className="border-brand-primary/10">
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <BookOpen className="w-5 h-5 text-brand-accent" /> All Published Works ({allStories.length})
      </CardTitle>
    </CardHeader>
    <CardContent>
      {allStories.length === 0 ? (
        <div className="text-center py-12">
          <BookOpen className="w-12 h-12 text-text-muted mx-auto mb-4" />
          <p className="text-text-secondary">No works published yet</p>
        </div>
      ) : (
        <div className="space-y-3">
          {allStories.map((story) => (
            <div key={story.id} className="flex items-center justify-between p-4 bg-surface-alt rounded-lg" data-testid={`admin-story-${story.id}`}>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <Link to={`/story/${story.id}`} className="font-medium text-text-primary hover:text-brand-accent truncate">{story.title}</Link>
                  <Badge className="text-xs" variant="outline">{story.genre}</Badge>
                  {story.is_draft && <Badge className="text-xs bg-yellow-100 text-yellow-700">Draft</Badge>}
                </div>
                <p className="text-sm text-text-muted mt-1">by {story.author_name} &bull; {story.view_count || 0} views &bull; {story.like_count || 0} likes</p>
              </div>
              <Button variant="destructive" size="sm" onClick={() => handleDeleteStory(story.id, story.title)} data-testid={`delete-story-${story.id}`}>Delete</Button>
            </div>
          ))}
        </div>
      )}
    </CardContent>
  </Card>
);
